/**
 * Clip timing for the rigged cats, read from the metadata that
 * tools/blender/rig_cat.py writes next to each rigged GLB. Strides are in
 * source-model units there; the game needs world units, so they are
 * scaled by the cat's modelScale here.
 */
import minnaAnim from "../../../assets/models-src/minna_anim.json";
import basilAnim from "../../../assets/models-src/basil_anim.json";
import type { CatClip, CatClipInfo } from "./CatAnimator";

interface RigClipMeta {
  duration: number;
  stride_length?: number;
}

function toClipInfo(
  clips: Record<string, RigClipMeta>,
  modelScale: number,
): Partial<Record<CatClip, CatClipInfo>> {
  const out: Partial<Record<CatClip, CatClipInfo>> = {};
  for (const [name, c] of Object.entries(clips)) {
    out[name as CatClip] = {
      duration: c.duration,
      ...(c.stride_length ? { stride: c.stride_length * modelScale } : {}),
    };
  }
  return out;
}

export const minnaAnimClips = (modelScale: number) =>
  toClipInfo(minnaAnim.clips as Record<string, RigClipMeta>, modelScale);
export const basilAnimClips = (modelScale: number) =>
  toClipInfo(basilAnim.clips as Record<string, RigClipMeta>, modelScale);
